export default __webpack_public_path__ + "static/media/background1.cc70172c.jpg";